import React, { useState } from "react";
import OrdersRow from "./OrdersRow";
import PacmanLoader from "react-spinners/PacmanLoader";
import { ClipLoader } from "react-spinners";
import RecordNotFound from "./RecordNotFound";
import FetchingError from "./FetchingError";

const OrderTable = ({
  orders = [],
  onViewOrder,
  orderStatusFilter = null,
  columnNames = {
    orderId: "Order ID",
    subject: "Subject",
    price: "Price",
    orderStatus: "Order Status",
    created: "Created",
    dueDate: "Due Date",
    actions: "Actions",
  },
  buttonText = "View Order", // Default button text
  loading,
  tableName,
  onRetry,
  error,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedFullPreview, setSelectedFullPreview] = useState("");

  return (
    <div className="relative font-inter flex flex-col min-h-[400px] flex-grow items-center">
      <div className={`${orders.length !== 0 && !loading ? 'border border-medium-gray ' : 'border-none'} rounded-[10px] max-h-[480px] overflow-auto scrollbar-none min-w-full`}>
        <table className="min-w-full border-collapse divide-y divide-medium-gray text-level">
          <thead>
            <tr className="h-[56px] sm:text-level-5 md:text-level-4 lg:text-level-3 text-secondary leading-[19.36px] font-semibold sticky top-0 bg-soft-gray">
              <th className="px-[15px] text-left">{columnNames.orderId}</th>
              <th className="px-[15px] text-left max-w-[120px] truncate">
                {columnNames.subject}
              </th>
              <th className="px-[15px] text-left">{columnNames.price}</th>
              <th className="px-[15px] text-left">{columnNames.orderStatus}</th>
              <th className="px-[15px] text-left">{columnNames.created}</th>
              <th className="px-[15px] text-left">{columnNames.dueDate}</th>
              <th className="px-[15px] text-left">{columnNames.actions}</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-medium-gray text-level-4">
            {loading ? (
              <tr>
                <td colSpan="9" className="text-center py-8">
                  {/* <div className="flex justify-center">
                    <PacmanLoader color="#60a5fa" loading={loading} size={15} />
                  </div> */}
                </td>
              </tr>
            ) : (error || orders?.length === 0) ?
              (
                <tr>
                 <td colSpan="9" className="text-center py-8">
                  <FetchingError 
                    error={error} 
                    isEmptyRecords={orders.length === 0} 
                    onRetry={onRetry}
                  /> 
                 </td>
                </tr>
              )
              :
            // orders.length === 0 ? (
            //   <tr>
            //     <td colSpan="9" className="text-center py-8">
            //       <RecordNotFound
            //         message="No Order found"
            //         onRetry={onRetry}
            //       />
            //     </td>
            //   </tr>
            // ) : 
            (
              orders.map((order, index) => (
                <OrdersRow
                  key={index}
                  order={order}
                  onViewOrder={onViewOrder}
                  setSelectedFullPreview={setSelectedFullPreview}
                  setOpenModal={setOpenModal}
                  buttonText={buttonText}
                  tableName={tableName}
                />
              ))
            )}
          </tbody>
        </table>
      </div>
      {loading &&
        <div className="flex flex-col flex-grow justify-center items-center w-full h-[100%]">
          <ClipLoader color="#60a5fa" loading={loading} size={44} speedMultiplier={0.5}/>
        </div>
      }
    </div>
  );
};

export default OrderTable;
